import {
    SET_LOADING_DFM_MESSAGE_CREATE,
    SET_DFM_MESSAGE_CREATE_SUCCESS,
    SET_DFM_MESSAGE_CREATE_FAILURE,
    SET_LOADING_DFM_MESSAGE_EDIT,
    SET_DFM_MESSAGE_EDIT_SUCCESS,
    SET_DFM_MESSAGE_EDIT_FAILURE,
    SHOW_DFM_MESSAGE_CREATE_MODAL,
    HIDE_DFM_MESSAGE_CREATE_MODAL,
    SHOW_DFM_MESSAGE_EDIT_MODAL,
    HIDE_DFM_MESSAGE_EDIT_MODAL,
} from '~/redux-modules/dfm-messages/constant'
import { INITIAL_STATE_TYPE } from '~/redux-modules/dfm-messages/types'

import { DFMMessageActionTypes } from './types'

const INITIAL_STATE: INITIAL_STATE_TYPE = {
    createMessage: {
        createdMessage: null,
        loading: false,
        error: null,
        showModal: false,
    },
    editMessage: {
        editedMessage: null,
        loading: false,
        error: false,
        showModal: false,
        messageBeingEdited: null,
    },
}

export const reducer = (
    state = INITIAL_STATE,
    action: DFMMessageActionTypes,
) => {
    switch (action.type) {
        case SHOW_DFM_MESSAGE_CREATE_MODAL:
            return {
                ...state,
                createMessage: {
                    error: null,
                    createdMessage: null,
                    loading: false,
                    showModal: true,
                },
            }
        case HIDE_DFM_MESSAGE_CREATE_MODAL:
            return {
                ...state,
                createMessage: {
                    error: null,
                    createdMessage: null,
                    loading: false,
                    showModal: false,
                },
            }
        case SHOW_DFM_MESSAGE_EDIT_MODAL:
            return {
                ...state,
                editMessage: {
                    error: null,
                    editedMessage: null,
                    loading: false,
                    showModal: true,
                    messageBeingEdited: action.payload,
                },
            }
        case HIDE_DFM_MESSAGE_EDIT_MODAL:
            return {
                ...state,
                editMessage: {
                    error: null,
                    editedMessage: null,
                    loading: false,
                    showModal: false,
                    messageBeingEdited: null,
                },
            }
        case SET_LOADING_DFM_MESSAGE_CREATE:
            return {
                ...state,
                createMessage: {
                    error: null,
                    createdMessage: null,
                    loading: true,
                    showModal: false,
                },
            }
        case SET_DFM_MESSAGE_CREATE_SUCCESS:
            return {
                ...state,
                createMessage: {
                    loading: false,
                    error: null,
                    createdMessage: action.payload,
                    showModal: false,
                },
            }
        case SET_DFM_MESSAGE_CREATE_FAILURE:
            return {
                ...state,
                createMessage: {
                    loading: false,
                    error: action.payload,
                    createdMessage: null,
                    showModal: false,
                },
            }
        case SET_LOADING_DFM_MESSAGE_EDIT:
            return {
                ...state,
                editMessage: {
                    loading: true,
                    error: null,
                    editedMessage: null,
                    messageBeingEdited: null,
                },
            }
        case SET_DFM_MESSAGE_EDIT_SUCCESS:
            return {
                ...state,
                editMessage: {
                    loading: false,
                    error: null,
                    editedMessage: action.payload,
                    messageBeingEdited: null,
                },
            }
        case SET_DFM_MESSAGE_EDIT_FAILURE:
            return {
                ...state,
                editMessage: {
                    loading: false,
                    error: action.payload,
                    editedMessage: null,
                    messageBeingEdited: null,
                },
            }

        default:
            return state
    }
}
